<app-tab>
  <dx-data-grid
    id="tagsGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{stateStorageKey: 'app-tags-grid'}"
    [masterDetail]="{ enabled: false, template: 'details' }"
    (onInitNewRow)="checkClone($event)"
    [libGridTitle]="{text: 'Les Cartes'}">

    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Code"
      dataField="code"
      dataType="number">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="async" message="Code existe déjà"
                           [validationCallback]="codeValidation"></dxi-validation-rule>
    </dxi-column>


    <dxi-column
      caption="État"
      dataField="taggable_id"
      cellTemplate="cellTemplate"
      [allowEditing]="false"
      [formItem]="{visible: false}">
      <div *dxTemplate="let data of 'cellTemplate'">
        <div><lib-badge (click)="showTaggable($event, data.row.data)" [color]="data.value ? 'gray' : 'green'">{{data.value ? 'Attachée' : 'Libre'}}</lib-badge></div>
      </div>
    </dxi-column>

    <dxi-column
      caption="Type"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="type">
    </dxi-column>

    <dxi-column
      caption="Categorie"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="category">
    </dxi-column>

    <dxi-column
      caption="Domaine"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="domain_name">
    </dxi-column>

    <dxi-column
      caption="BU"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="business_unit_name">
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false">
      <div *dxTemplate="let cellInfo of 'domainChooser';">
        <app-user-domains-chooser (valueChange)="cellInfo.setValue($event)"
                                  [id]="cellInfo.value"></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Type"
      dataField="type_id"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-lookup [dataSource]="tagTypes" valueExpr="id" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Categorie"
      dataField="category_id"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-lookup [dataSource]="tagCategories" valueExpr="id" displayExpr="name"></dxo-lookup>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column dataField="attributes"
                caption=""
                editCellTemplate="attributesSelector"
                [showInColumnChooser]="false"
                [allowFiltering]="false"
                [allowSearch]="false"
                [visible]="false">
      <div *dxTemplate="let cellInfo of 'attributesSelector';">
        <lib-tag-attributes-editor (attributesChange)="cellInfo.setValue($event)"
                                   [attributes]="cellInfo.value"
                                   [parentSaveClick]="editSaveClick$"
                                   [parentCancelClick]="editCancelClick$"></lib-tag-attributes-editor>
      </div>
    </dxi-column>

    <dxi-column type="buttons" [allowHiding]="false" [width]="110">
      <dxi-button
        hint="Liste des attributes"
        icon="info"
        [onClick]="showAttributes"></dxi-button>
      <dxi-button
        hint="Dupliquer la carte"
        icon="copy"
        [onClick]="cloneTag"></dxi-button>
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxo-editing
      mode="popup"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit">

      <dxo-popup width="50%" [toolbarItems]="editToolbarItems"></dxo-popup>

      <dxo-form labelLocation="top">
        <dxi-item itemType="group" colSpan="2" colCount="2" caption="Général">
          <dxi-item dataField="code"></dxi-item>
          <dxi-item dataField="domain_id"></dxi-item>
          <dxi-item dataField="type_id"></dxi-item>
          <dxi-item dataField="category_id"></dxi-item>
        </dxi-item>

        <dxi-item itemType="group" colSpan="2" colCount="1" caption="Attributes">
          <dxi-item dataField="attributes" [label]="{visible: false}"></dxi-item>
        </dxi-item>
      </dxo-form>
    </dxo-editing>


    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" fileName="liste-cartes-"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <div *dxTemplate="let cell of 'details'">
      <dx-data-grid
        [dataSource]="cell.data.attributes"
        [showBorders]="true"
        [showColumnLines]="true"
        [showRowLines]="true"
        [showColumnHeaders]="false"
        [columnAutoWidth]="true">
        <dxi-column cellTemplate="cellTemplate" caption="Nom" dataField="name" dataType="string" width="10%">
        </dxi-column>
        <dxi-column caption="Valeur" dataField="value" dataType="string">
        </dxi-column>
        <div *dxTemplate="let data of 'cellTemplate'">
          <span class="underline">{{data.value}}</span>
        </div>
      </dx-data-grid>
      <div class="py-2">
        <dx-button
          type="default"
          text="Ajouter"
          [width]="120"
          (onClick)="addTagAttr(cell.rowIndex)">
        </dx-button>
      </div>
    </div>
  </dx-data-grid>
</app-tab>
<dx-popover
  [target]="taggableEl"
  position="top"
  [width]="300"
  [(visible)]="taggableVisible">
  <div *dxTemplate="let data = model of 'content'">
    {{taggable.taggable_name}} - (ID: {{taggable.taggable_id}})
  </div>
</dx-popover>
